import { render, staticRenderFns } from "./MonthlyAppointments.vue?vue&type=template&id=78f21ab8&"
import script from "./MonthlyAppointments.vue?vue&type=script&lang=ts&"
export * from "./MonthlyAppointments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports